<script lang="ts" setup>
import { RhsLoadingErrorReason, SmrLoadingErrorReason } from '@/store/modules/stay/smr/types'

defineProps<{
  stayId: number
  rhsId: number
  reason: RhsLoadingErrorReason | SmrLoadingErrorReason | null
}>()

</script>

<template>
  <div
    v-if="reason"
    class="stay-page-error-message col-auto mx-auto"
  >
    <div
      v-if="reason === SmrLoadingErrorReason.SMR_STAY_NOT_FOUND"
    >
      <h1>Le séjour SMR (id : {{ stayId }}) auquel est associé le RHS (id : {{ rhsId }}) n'a pas pu être trouvé.</h1>
      <div>Cette erreur peut être provoquée par les causes suivantes :</div>
      <ul>
        <li>L'identifiant fourni est erroné ou n'existe pas.</li>
        <li>Le séjour n'a pas encore été importé par Sancare (probable si le séjour est récent).</li>
      </ul>
    </div>
    <div
      v-else-if="reason === RhsLoadingErrorReason.RHS_NOT_FOUND"
    >
      <h1>Le RHS demandé (id : {{ rhsId }}) n'a pas pu être trouvé.</h1>
      <div>Cette erreur peut être provoquée par les causes suivantes :</div>
      <ul>
        <li>L'identifiant fourni est erroné ou n'existe pas.</li>
        <li>Le RHS n'a pas encore été importé par Sancare (probable s'il est récent).</li>
      </ul>
    </div>
    <div
      v-else-if="reason === RhsLoadingErrorReason.RHS_UNKNOWN"
    >
      <h1>Le RHS demandé (id : {{ rhsId }}) n'existe pas dans le séjour SMR (id : {{ stayId }}).</h1>
      <div>Cette erreur peut être provoquée par les causes suivantes :</div>
      <ul>
        <li>L'URL spécifiée est invalide.</li>
        <li>Le RHS n'a pas encore été importé par Sancare (probable s'il est récent).</li>
      </ul>
    </div>
    <div v-else>
      <h1>Une erreur est survenue...</h1>
      <div>Le RHS (id : {{ rhsId }}) ne peut pas être affiché, car une erreur est survenue lors de son chargement.</div>
      <div>Si le problème se répète, n'hésitez pas à envoyer un rapport de bug à Sancare (icône en haut à droite de l'écran).</div>
    </div>
  </div>
</template>
